import { render, staticRenderFns } from "./Lien.vue?vue&type=template&id=3c6112b9&"
import script from "./Lien.vue?vue&type=script&lang=ts&"
export * from "./Lien.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6112b9')) {
      api.createRecord('3c6112b9', component.options)
    } else {
      api.reload('3c6112b9', component.options)
    }
    module.hot.accept("./Lien.vue?vue&type=template&id=3c6112b9&", function () {
      api.rerender('3c6112b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/Lien.vue"
export default component.exports